import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[passwordDirective]'
})
export class AppPasswordDirective {
    private _shown = false;

    constructor(private el: ElementRef) {
        this.setup();
    }

    toggle(i: HTMLElement) {
        console.log('password directive');
        this._shown = !this._shown;
        if (this._shown) {
            this.el.nativeElement.setAttribute('type', 'text');
            i.style.color = "#2e5564";
        } else {
            this.el.nativeElement.setAttribute('type', 'password');
            i.style.color = "gray";
        }
    }

    setup() {
        const parent = this.el.nativeElement.parentNode;
        const i = document.createElement('i');
        i.classList.add("far", "fa-eye", 'pointer');
        i.style.color = "gray";
        i.style.position = "relative";
        i.style.top = "-28px";
        i.style.left = "calc(100% - 30px)";

        i.addEventListener('click', (event) => {
            this.toggle(i);
        });
        parent.appendChild(i);
    }
}
